// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__254AC","header":"ReportDetails_header__20EQK","title":"ReportDetails_title__1ATUu","left":"ReportDetails_left__2NMPS"};